// import {AuthModel} from '../models/AuthModel'
// import {UserModel} from '../models/UserModel'
import { API_URL } from '../../../../setup/axios/axios'


export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/api/Account/GetUserByToken`

export const LOGIN_URL = `${API_URL}/api/Account/Login`
export const REGISTER_URL = `${API_URL}/api/Account/SignUp`
export const REQUEST_PASSWORD_URL = `${API_URL}/api/Account/forgotPassword`
export const CONFIRM_EMAIL_URL = `${API_URL}/api/Account/ConfirmEmail`

// Server should return AuthModel
export function login(axiosPrivate : any, Email: string, Password: string) {
  
  console.log('Login URL --- ',LOGIN_URL);
  
  return axiosPrivate.post(LOGIN_URL, {Email, Password})
}

// Server should return AuthModel
export function register(axiosPrivate : any,Email: string, Firstname: string, Lastname: string, Password: string) {

  return axiosPrivate.post(REGISTER_URL, {
    Email,
    Firstname,
    Lastname,
    Password,
  })
}

//-----------------------------------------
export function confirmEmail(axiosPrivate : any, model : any) {
  console.log(
    'in confirm Email Function---- at line 34--- AuthCURD---model---',
     model
    );
  
  return axiosPrivate.post(CONFIRM_EMAIL_URL, model)
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(axiosPrivate : any, email: string) {
  return axiosPrivate.post(REQUEST_PASSWORD_URL, {email})
}

export function getUserByToken(axiosPrivate : any) {
  // Authorization head should be fulfilled in interceptor.
  // Check common redux folder => setupAxios
  return axiosPrivate.get(GET_USER_BY_ACCESSTOKEN_URL)
}
